export const IMAGE_FRAME_CLASS_NAME =
  "bg-secondary relative flex aspect-square w-full items-center justify-center overflow-hidden rounded-md lg:rounded-none";

export const DEFAULT_DETAILS_IMAGE_ZOOM_LEVEL = 1;
export const MID_DETAILS_IMAGE_ZOOM_LEVEL = 2;
export const MAX_DETAILS_IMAGE_ZOOM_LEVEL = 3;
export const DETAILS_IMAGE_ZOOM_THROTTLE_MS = 50;
export const DETAILS_IMAGE_ZOOM_CENTER_PERCENT = 50;
export const DETAILS_IMAGE_ZOOM_MIN_PERCENT = 0;
export const DETAILS_IMAGE_ZOOM_MAX_PERCENT = 100;
export const DETAILS_IMAGE_ZOOM_DRAG_THRESHOLD_PX = 6;
